import { Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide";

import CardGraph from "./CardGraph";
import { SkeletonCarouselPanels } from "./skeletons/home";

const carouselOptions = {
    interval: 2000,
    padding: {
        right: "4rem",
    },
    arrows: false,
    gap: ".1rem",
    perMove: 1,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: true,
    rewind: true,
    mediaQuery: "min",
    breakpoints: {
        375: {
            perPage: 1,
        },
        768: {
            perPage: 1,
            autoplay: true,
            arrows: true,
        },
        1024: {
            perPage: 1,
        },
        1440: {
            perPage: 1,
        },
        1920: {
            perPage: 1,
        },
        2000: {
            perPage: 1,
        },
    },
};

export default function GraphCarousel({ content, isLoading, theme, componentId, bgColor, spacingTop, spacingBottom }) {
    return (
        <div
            className={`carousel pt-${spacingTop} pb-${spacingBottom}`}
            id={componentId || null}
            style={{ "--bg-color": bgColor || null, height: "100%" }}
        >
            {isLoading ? (
                <SkeletonCarouselPanels />
            ) : (
                <div className="component-padding">
                    <Splide hasTrack={false} options={carouselOptions} className="--react --graph">
                        <SplideTrack>
                            {content.filter((item) => item.mostrar).map((item, index) => (
                                <SplideSlide key={index}>
                                    <CardGraph item={item} />
                                </SplideSlide>
                            ))}
                        </SplideTrack>

                        <div
                            className={`arrows-container ${theme === "light" && "--theme-light"} ${
                                theme === "dark" && "--theme-dark"
                            }`}
                        >
                            <div className="arrows-wrapper">
                                <div className="splide__arrows">
                                    <button className="splide__arrow splide__arrow--prev">
                                        <div className="chevron">
                                            <svg
                                                width="9"
                                                height="16"
                                                viewBox="0 0 9 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M8 1L1 8L8 15"
                                                    stroke="currentColor"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </div>
                                    </button>
                                    <button className="splide__arrow splide__arrow--next">
                                        <div className="chevron">
                                            <svg
                                                width="9"
                                                height="16"
                                                viewBox="0 0 9 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M1 15L8 8L0.999999 1"
                                                    stroke="currentColor"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </div>
                                    </button>

                                    <div className="splide__progress">
                                        <div className="splide__progress__bar"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Splide>
                </div>
            )}
        </div>
    );
}
